/*jshint esversion: 6 */
$(document).ready(function () {
    $("#btnClose").click(function () {
        SetCookie();
    });
    GetCookie();
});

var divunsupportedbrowser = $("#div-unsupported-browser");

function SetCookie() {
    document.cookie = "unsupported-browser;expires=0";
    HideAlert();
}

function GetCookie() {
    if (document.cookie.indexOf("unsupported-browser") !== -1) {
        HideAlert();
    }
}

function HideAlert() {
    if (divunsupportedbrowser != undefined) {
        divunsupportedbrowser.hide();
    }
}